<div class="form-group">
  <label for="name" class="col-sm-2 control-label">Name</label>
  <div class="col-sm-10">
    <input type="text" class="form-control" name="name" id="name" placeholder="Portfolio Name" [(ngModel)]="portfolio.name" required>
  </div>
</div>

<app-shared-address [model]="portfolio"></app-shared-address>

<app-shared-contact-details [model]="portfolio"></app-shared-contact-details>

<div class="form-group">
  <div class="col-sm-offset-2 col-sm-10 text-right">
    <button type="submit" class="btn btn-success">Save</button>
  </div>
</div>
